import styled, {css} from "styled-components";

export const WrapperPositionAlignmentDefaultBox = styled.div<{verticalMode?: boolean}>`
    position: absolute;
    ${props => props.verticalMode ? css`
        top: 0;
    ` : css`
        bottom: 0;
    `}
    left: 0;
    /* Solves this iOS bug: https://dev.azure.com/888holdings/GamingNDL/_workitems/edit/2547170 */
    /* It seems that it doesn't matter the value of z-index, just that it is set */
    z-index: 1;
`;